import React from 'react';
import Icon from '../../../components/AppIcon';

const ComparisonMatrix = ({ buildings, metrics }) => {
  const getValueColor = (value, metric) => {
    if (metric?.type === 'time') {
      if (value <= 24) return 'text-success';
      if (value <= 48) return 'text-warning';
      return 'text-error';
    }
    if (metric?.type === 'percentage') {
      if (value >= 90) return 'text-success';
      if (value >= 75) return 'text-warning';
      return 'text-error';
    }
    return 'text-foreground';
  };

  const formatValue = (value, metric) => {
    if (metric?.type === 'time') return `${value}h`;
    if (metric?.type === 'percentage') return `${value}%`;
    if (metric?.type === 'currency') return `$${value?.toLocaleString()}`;
    return value;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">Detailed Comparison Matrix</h3>
          <p className="caption text-muted-foreground">Operational metrics across facilities</p>
        </div>
        <button className="flex items-center gap-2 px-3 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-smooth">
          <Icon name="Download" size={16} />
          <span className="hidden md:inline">Export</span>
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[600px]">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-2 text-sm font-semibold text-foreground sticky left-0 bg-card">Metric</th>
              {buildings?.map(building => (
                <th key={building?.id} className="text-center py-3 px-2 text-sm font-semibold text-foreground">
                  {building?.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {metrics?.map((metric, index) => (
              <tr key={index} className="border-b border-border hover:bg-muted/50 transition-smooth">
                <td className="py-3 px-2 sticky left-0 bg-card">
                  <div className="flex items-center gap-2">
                    <Icon name={metric?.icon} size={16} className="text-muted-foreground" />
                    <div>
                      <p className="text-sm font-medium text-foreground">{metric?.label}</p>
                      <p className="caption text-muted-foreground">{metric?.unit}</p>
                    </div>
                  </div>
                </td>
                {buildings?.map(building => {
                  const value = building?.metrics?.[metric?.key];
                  return (
                    <td key={building?.id} className="py-3 px-2 text-center">
                      <span className={`text-sm font-semibold data-text ${getValueColor(value, metric)}`}>
                        {formatValue(value, metric)}
                      </span>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-4 p-4 bg-muted rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-foreground mb-1">Performance Insights</p>
            <p className="caption text-muted-foreground">
              Buildings with response times under 24 hours and satisfaction above 90% are considered high-performing. 
              Click on any metric to view detailed breakdown and improvement recommendations.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparisonMatrix;